export interface PriceRow {
  date: string;
  entry: number;
  mid: number;
  exit: number;
  problem?: string;
  warning?: string;
}

export function parsePriceRows(text: string, lastMid: number): PriceRow[] {
  let previous = lastMid;
  return text
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line && !/^date/i.test(line))
    .map((line) => {
      const [date = '', entry = '', mid = '', exit = ''] = line
        .split(/[,\t]/)
        .map((cell) => cell.trim());
      const row: PriceRow = { date, entry: Number(entry), mid: Number(mid), exit: Number(exit) };
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) row.problem = 'Date must be YYYY-MM-DD';
      else if (
        ![row.entry, row.mid, row.exit].every((value) => Number.isFinite(value) && value > 0)
      )
        row.problem = 'Prices must be positive numbers';
      else if (!(row.exit <= row.mid && row.mid <= row.entry))
        row.problem = 'Expected exit ≤ mid ≤ entry';
      else if (previous && Math.abs(row.mid / previous - 1) > 0.02)
        row.warning = `Mid moved ${((row.mid / previous - 1) * 100).toFixed(1)}% since the last price`;
      if (!row.problem) previous = row.mid;
      return row;
    });
}
